'use client';

import { Box, ImageLabel, Label } from '@wishket/design-system';

export const AiLabel = () => {
  return (
    <Box className="flex gap-2 pt-1.5" data-testid="ai-label">
      <ImageLabel type="ai" />
      <Box className="flex items-center">
        <Label.Root
          size="sm"
          variant="primary"
          type="filled"
          className="h-fit w-[47px] font-medium"
        >
          <Label.Text>BETA</Label.Text>
        </Label.Root>
      </Box>
    </Box>
  );
};
